import { EuiListGroup, EuiListGroupItem } from "@elastic/eui";
import React from "react";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";
import TripSection from "../shared/TripSection";
import { TRADE_WIND } from "../../../../constants/style/colors";

const generateListItem = ({ label, icon }, i) => (
    <EuiListGroupItem
        key={i}
        onClick={() => {}}
        label={label}
        icon={icon}
    />
);

export const TripDetailsSectionWrapper = styled.div`
    .trip-details__confirmation-checklist-title {
        color: ${TRADE_WIND};
        margin-left: 7px;
    }
`;

export default function TripFieldsConfirmationCheckList({ checkList }) {
    const listOptions = [];

    if (checkList.isSupplierConfirmed) {
        listOptions.push({
            onClick: () => {},
            label: <FormattedMessage id="trip.fields-confirmation-checklist-supplier" />,
        });
    }
    if (checkList.isDriverConfirmed) {
        listOptions.push({
            onClick: () => {},
            label: <FormattedMessage id="trip.fields-confirmation-checklist-driver" />,
        });
    }
    if (checkList.isTruckConfirmed) {
        listOptions.push({
            onClick: () => {},
            label: <FormattedMessage id="trip.fields-confirmation-checklist-truck" />,
        });
    }

    return (
        <TripSection
            headerTitle={<FormattedMessage id="trip.fields-confirmation-checklist-section-title" />}
            headerIconType="checkInCircleFilled"
            size="sm"
            isIconSection
            iconColor={TRADE_WIND}
        >
            <div className="checklist-wrapper">
                <EuiListGroup
                    flush
                    wrapText
                >
                    {listOptions.map(generateListItem)}
                </EuiListGroup>
            </div>
        </TripSection>
    );
}
